export default {
  app: {
    guestUser: 'Guest User',
    tapViewProfile: 'Tap to view profile',
    tapSignIn: 'Tap to sign in',
    browse: 'Browse',
    account: 'Account',
    home: 'Home',
    discover: 'Discover',
    addPlace: 'Add Place',
    myProfile: 'My Profile',
    signOut: 'Sign Out',
    signIn: 'Sign In',
    login: 'Log in',
    footer: 'Find your perfect home',
    searchPlaceholder: 'Search for housing, dorms...',
    language: 'Language'
  },
  reviews: {
    title: '{count} Student Reviews',
    searchPlaceholder: 'Search reviews by keyword, reviewer, school...',
    allRooms: 'All Rooms',
    selectedRoom: 'Selected Room',
    latest: 'Latest',
    earliest: 'Earliest',
    highestRated: 'Highest Rated',
    lowestRated: 'Lowest Rated',
    priceHighLow: 'Price High to Low',
    priceLowHigh: 'Price Low to High',
    noSearchResults: 'No reviews found matching "{query}". Try a different keyword.',
    anonymous: 'Anonymous',
    edit: 'EDIT',
    delete: 'DELETE',
    viewDetails: 'VIEW DETAILS',
    yourself: 'Yourself',
    recommended: 'Recommended',
    deposit: 'deposit',
    flatmate: 'flatmate',
    flatmates: 'flatmates',
    billsIncluded: 'Bills included',
    sharedBath: 'Shared bath',
    privateBath: 'Private bath',
    biggestIssue: 'Biggest issue:',
    noContent: 'No review content provided.',
    helpful: 'Helpful?',
    comments: 'Comments',
    leaveComment: 'Leave a comment...',
    submit: 'Submit'
  },
  translation: {
    seeOriginal: 'See Original',
    seeTranslation: 'See Translation',
    translating: 'Translating...'
  },
  auth: {
    loginRequiredTitle: 'Please log in',
    loginRequiredText: 'You need an account to share or edit a review on Sparrow.',
    loginRequiredConfirm: 'Log in',
    loginRequiredCancel: 'Not now',
    adminOnlyTitle: 'Admin only',
    adminOnlyText: 'This page is only available to Sparrow admins.'
  },
  home: {
    searchLabel: 'What are you looking for?',
    seeMore: 'See more',
    trustedBy: 'Trusted by students from',
    perfectHomeLine1: 'Find Your Perfect',
    perfectHomeLine2: 'Student Home',
    realReviews: 'Real reviews. Real ratings. Real community.',
    businessSubtitle: 'Looking to grow your business?',
    businessTitle: 'Strengthen your reputation with reviews on Sparrow',
    getStarted: 'Get started',
    popularListings: 'Popular listings',
    topRatedHousing: 'Top rated housing',
    noPopularListings: 'No popular listings available at the moment.',
    partnerTitle: 'Partner with Sparrow',
    partnerSubtitle: 'Connect with thousands of students looking for quality housing.',
    fullName: 'Full Name',
    workEmail: 'Work Email',
    keepUpdated: 'Keep me updated on Sparrow news',
    submitRequest: 'Submit Request',
    helpMillions: 'Help millions make the right choice',
    shareExperience: 'Share your experience on Sparrow, where reviews make a difference.',
    loginOrSignUp: 'Login or sign up',
    recentReviews: 'Recent reviews',
    noRecentReviews: 'No recent reviews available at the moment.',
    beFirstReview: 'Be the first to share your experience!',
    rewardTitlePrefix: 'Win a',
    rewardTitleSuffix: 'Starbucks e-Gift',
    rewardLeadPrefix: 'For the first',
    rewardLeadSuffix: 'qualifying submissions: publish a verified housing review, complete the checklist, and we will send reward details by email after approval.',
    loadingProgress: 'Loading progress...',
    roundFull: 'Round full',
    campaignStatsError: "Couldn't load campaign stats. Try again later.",
    showLess: 'Show less',
    viewMore: 'View more',
    howItWorks: 'How it works',
    rewardStep1: 'Publish a housing review on Sparrow with photos and a written narrative.',
    rewardStep2: 'Complete the checklist: minimum photos plus substantive comments on other listings.',
    rewardStep3: 'Submit for verification; once approved, reward instructions go to your account email.',
    rewardFoot: 'Your profile shows the same checklist progress our team uses when reviewing submissions.',
    rewardsClaimed: '{approved} / {limit} rewards claimed',
    openProfileChecklist: 'Open profile checklist',
    signInToParticipate: 'Sign in to participate',
    footerTagline: 'The trusted student housing voice.',
    platform: 'Platform',
    features: 'Features',
    community: 'Community',
    support: 'Support',
    company: 'Company',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    stayUpdated: 'Stay Updated',
    subscribeText: 'Subscribe to get latest updates from Sparrow',
    filters: {
      all: 'All',
      companies: 'Companies',
      universities: 'Universities'
    },
    categories: {
      dorms: 'Dorms',
      apartments: 'Apartments',
      sublets: 'Sublets',
      roommates: 'Roommates',
      companies: 'Companies',
      universities: 'Universities',
      studios: 'Studios',
      shared: 'Shared Housing'
    },
    heroCards: {
      trusted: {
        title: 'Find Student Housing You can trust',
        subtitle: 'Discover, read and write your student story'
      },
      nest: {
        title: 'Find Your Perfect Nest',
        subtitle: 'Real reviews from real students. No more hidden surprises.'
      }
    },
    featureCards: {
      anonymous: {
        title: 'Anonymous Reviews',
        text: 'Share honest experiences about your nest without revealing your identity.'
      },
      rating: {
        title: 'Housing Rating',
        text: 'Contribute to an overall rating for each dorm reflecting combined feedback.'
      },
      verified: {
        title: 'University Verified',
        text: 'Only University email users can register, ensuring a trusted space.'
      },
      community: {
        title: 'Community Forum',
        text: 'Connect with students to share advice, ask questions, and find support.'
      }
    }
  },
  pages: {
      AddHouse: {
        add_a_house_91f72fd: 'Add a House',
        add_a_new_room_3b3d65d: 'Add a new room',
        add_a_room_adce167: '+ Add a room',
        add_a_room_caf6776: 'Add a room',
        address_information_477f95d: 'Address Information',
        address_no_24637ab: 'Address No.',
        agency_5c47e26: 'Agency',
        and_8278d2a: ', and',
        area_2745deb: 'Area',
        by_continuing_i_confirm_that_i_hav_9d12334: 'By continuing, I confirm that I have read and agree to Sparrow\'s',
        cancel_77dfd21: 'Cancel',
        community_guidelines_7534366: 'Community Guidelines',
        continue_2e02623: 'Continue',
        continue_ff3dbb4: 'CONTINUE',
        district_c0cb139: 'District',
        drag_the_pin_on_the_map_below_if_t_a574c10: 'Drag the pin on the map below if the marker isn\'t on the right building.',
        e_g_98_dbfc94f: 'e.g. 98',
        e_g_clear_water_bay_rd_56f3f57: 'e.g. Clear Water Bay Rd.',
        e_g_gf_1f_718c4f7: 'e.g., GF, 1F',
        e_g_hkust_accommodation_office_sun_58b5597: 'e.g. HKUST Accommodation Office / Sunshine Agency',
        e_g_room_a_b_unit_c_3cf8567: 'e.g., Room A, B / Unit C',
        e_g_tai_po_tsai_village_625e661: 'e.g. Tai Po Tsai Village',
        filled_in_from_the_selected_addres_a19ab88: 'Filled in from the selected address. You can still edit any field.',
        floor_7db82f7: 'Floor',
        got_it_5b8027f: 'Got it',
        location_type_58cd45f: 'Location Type',
        managed_by_name_4763975: 'Managed By Name',
        managed_by_type_12a4cac: 'Managed By Type',
        none_of_these_is_mine_create_new_h_c1b0e04: 'None of these is mine — create new house',
        off_campus_de6195e: 'Off-Campus',
        on_campus_ee963a7: 'On-Campus',
        pin_exact_location_for_the_map_d58635d: 'Pin exact location (for the map)',
        pinned_d14f89f: '📍 Pinned:',
        privacy_policy_9db108b: 'Privacy Policy',
        private_landlord_e5b909a: 'Private Landlord',
        property_type_ad794a4: 'Property Type',
        region_0f21717: 'Region',
        save_property_only_055ca3f: 'Save Property Only',
        search_for_existing_house_9740309: 'Search for existing house',
        searching_1a6a5ba: 'Searching…',
        select_area_8f1f4cc: 'Select Area',
        select_district_666f30d: 'Select District',
        select_location_type_710db92: 'Select Location Type',
        select_managed_by_type_8832a1e: 'Select Managed By Type',
        select_region_570539e: 'Select Region',
        share_a_new_student_housing_locati_03e69d1: 'Share a new student housing location with the community',
        street_b454109: 'Street',
        terms_of_use_9773841: 'Terms of Use',
        type_a_real_address_e_g_clear_wate_29ecd02: 'Search by building or estate, e.g. Metro City Phase 1',
        type_to_find_your_room_6bba2e8: 'Type to find your room',
        type_to_find_your_room_ee10746: 'Type to find your room...',
        type_to_search_address_or_place_na_a379ebd: 'Type to search address or place name...',
        university_715432d: 'University'
      },
      AddHouseRoom: {
        add_a_new_room_349da31: 'Add a New Room',
        e_g_g_f_1_f_5455941: 'e.g. G/F, 1/F',
        e_g_rooma_roomb_a3f6e21: 'e.g. RoomA, RoomB',
        floor_7db82f7: 'Floor',
        got_it_5b8027f: 'Got it',
        input_manually_726a1dd: '✍️ Input manually',
        input_manually_new_floor_new_room_e2870be: '✍️ Input manually (new floor / new room)',
        property_9ae33a7: 'Property',
        property_type_ad794a4: 'Property Type',
        room_90e2fca: 'Room',
        room_information_48daf6c: 'Room Information',
        search_for_existing_room_fef943d: 'Search for existing room',
        try_finding_the_room_if_it_isn_t_l_df482ef: 'Try finding the room. If it isn\'t listed, click "Input manually" below to add a new floor or unit.',
        type_to_find_your_room_ee10746: 'Type to find your room...'
      },
      AdminLocations: {
        admin_house_locations_11562f6: 'Admin · House locations',
        drag_any_pin_to_correct_its_locati_46eadc8: 'Drag any pin to correct its location. Saves immediately. Houses with no pin yet appear in the left list — click one to drop it on the visible map center.',
        filter_by_name_district_area_manag_fd68d57: 'Filter by name, district, area, manager…',
        no_matches_0be6a25: 'No matches.',
        no_pin_8d7ac9d: 'no pin',
        saving_56a2285: 'Saving…'
      },
      Log_Reg: {
        already_have_an_account_8559034: 'Already have an account?',
        back_to_sign_up_8927212: '← Back to sign up',
        create_account_eff4fd8: 'Create Account',
        domain_not_supported_ef85cbc: 'Domain Not Supported',
        don_t_have_an_account_f838dc1: 'Don\'t have an account?',
        email_84add5b: 'Email',
        enter_your_personal_details_and_st_26cd777: 'Enter your personal details and start your journey with us',
        forgot_password_4c29f7f: 'Forgot password?',
        full_name_64346b4: 'Full Name',
        hello_friend_c896fbc: 'Hello, Friend!',
        hello_friend_enter_your_personal_d_faf18f4: 'Hello, Friend! Enter your personal details and start your journey with us.',
        note_optional_4e39567: 'Note (optional)',
        password_8be3c94: 'Password',
        sign_in_f8492cc: 'Sign In',
        sign_in_to_continue_to_your_accoun_791f0bb: 'Sign in to continue to your account',
        sign_up_2ba4023: 'Sign Up',
        slide_to_verify_68b61e8: 'Slide to verify',
        the_email_you_entered_9680274: 'The email you entered',
        to_keep_connected_with_us_please_l_a7f6a8b: 'To keep connected with us please login with your personal info',
        try_again_042c862: 'Try again',
        university_email_2d10f47: 'University Email',
        university_name_eb33cf0: 'University Name',
        use_your_hong_kong_university_emai_9179d02: 'Use your Hong Kong university email to join',
        verification_code_50cdc18: 'Verification Code',
        verified_f6cc6a5: 'Verified!',
        verify_dda6ac2: 'Verify',
        welcome_back_1c90894: 'Welcome Back',
        welcome_back_7927e5d: 'Welcome Back!',
        welcome_back_to_keep_connected_wit_235aae1: 'Welcome Back! To keep connected with us please login with your personal info.',
        your_university_is_not_yet_on_spar_31e8c27: 'Your university is not yet on Sparrow. Request access below.',
        agree_terms_prefix_fd9c616: 'I agree to Sparrow\'s ',
        terms_of_use_link_3e81a3c: 'Terms of Use',
        agree_terms_middle_66e6680: ' and acknowledge the ',
        privacy_policy_link_c3fe6d6: 'Privacy Policy',
        agree_terms_and2_e1f9f9e: ' and ',
        pics_link_f2a31b8: 'Personal Information Collection Statement',
        agree_account_personal_b66aa09: 'I understand that my student account is personal and may not be shared with or used on behalf of a landlord, operator, university housing office, agency or other housing provider.',
        agreement_required_title_f81748c: 'Agreement Required',
        agreement_required_text_14d1733: 'Please agree to the Terms of Use and Privacy Policy, and confirm your account is personal, before creating an account.'
      },
      PrivacyPolicy: {
        title_e71f479: 'Privacy Policy',
        subtitle_ec63f07: 'How Sparrow collects, uses, shares and protects personal data'
      },
      TermsOfUse: {
        title_b345ab3: 'Terms of Use',
        subtitle_205f278: 'Rules governing access to and use of the Sparrow Platform'
      },
      rateTheHouse: {
        before_you_submit_title_7f3a1c2: 'Before you submit',
        consent_honest_label_4d8e2b1: 'This review is based on my direct experience and is honest and accurate to the best of my knowledge.',
        consent_identity_label_9c1f6a3: 'I understand that Sparrow will not display my name or university email, but someone familiar with the room or circumstances may still infer my identity.',
        consent_provider_share_label_2b7d5e4: 'I understand that Sparrow may provide the responsible housing provider with filtered, redacted, paraphrased, room-specific or aggregated insights from my review, without ordinarily providing my name, email or private account details.',
        consent_photo_rights_prefix_6a4f9d0: 'I took these photos or have permission to share them, and I grant Sparrow the rights described in the ',
        consent_photo_rights_link_3e8c1b5: 'Terms of Use',
        consent_photo_rights_suffix_1d9a7c6: '.',
        consent_photo_no_private_label_8f2b3a1: 'These photos do not show an identifiable person, personal documents, names, contact details, access codes, keys, security information or other private information.',
        consent_required_review_text_5c6d8e2: 'Please confirm all three review consent checkboxes before submitting your review.',
        consent_required_photo_text_9b3f1a4: 'Please confirm both photo consent checkboxes before submitting, since you have attached photos to this review.'
      },
      recommendHouse: {
        '1_bed_fb8e3a4': '1 Bed',
        '2_beds_435bff3': '+2 Beds',
        add_a_review_now_c2a5684: 'ADD A REVIEW NOW →',
        add_to_multi_location_search_e76d666: 'Add to multi-location search',
        agency_5c47e26: 'Agency',
        all_6a72085: 'All',
        any_322444d: 'Any',
        apply_cfea419: 'Apply',
        apply_filter_aa3dea2: 'Apply Filter',
        area_2745deb: 'Area',
        avg_price_ec4ddd4: 'Avg price:',
        bathrooms_2a0b1c2: 'Bathrooms',
        bedroom_f69fecd: 'Bedroom',
        bunk_bed_3de27ba: 'Bunk bed',
        clear_719ea39: 'Clear',
        clear_all_c043160: 'Clear all',
        close_filters_c2db1e0: 'Close filters',
        details_dc3decb: 'Details',
        district_c0cb139: 'District',
        filters_96e5782: 'Filters',
        filters_map_c2ffed9: 'Filters & Map',
        it_is_not_what_you_are_looking_for_6b7739a: 'IT IS NOT WHAT YOU ARE LOOKING FOR?',
        likes_ea70b16: 'Likes:',
        max_a95e85a: 'Max',
        max_floor_5363671: 'Max Floor',
        max_price_de84944: 'Max Price',
        max_roommates_27e71b8: 'Max Roommates',
        min_7eb0cee: 'Min',
        min_floor_7336b36: 'Min Floor',
        min_price_f9cc312: 'Min Price',
        min_roommates_bfeb7ec: 'Min Roommates',
        my_location_fba0847: 'My Location',
        off_campus_6fd4374: 'Off-campus',
        on_campus_de78303: 'On-campus',
        personal_40f0732: 'Personal',
        please_select_the_area_you_are_sea_82558be: 'Please select the area you are searching for and we will recommend properties in that area.',
        price_range_42363d0: 'Price Range',
        private_landlord_e5b909a: 'Private Landlord',
        provider_7ceee3f: 'Provider',
        provider_f60f814: 'Provider:',
        region_0f21717: 'Region',
        remove_location_d805001: 'Remove location',
        reset_44c57ab: 'Reset',
        results_612e12d: 'Results',
        reviews_17f8ebd: 'Reviews:',
        room_type_6320f14: 'Room Type',
        rooms_and_beds_1fc6dd7: 'Rooms and beds',
        scanning_the_network_for_homes_5c93823: 'Scanning the network for homes...',
        search_bce0641: 'Search',
        search_houses_dorms_locations_248bdb2: 'Search houses, dorms, locations...',
        select_a_university_80d42c5: 'Select a university…',
        select_location_9fa73f5: 'Select Location',
        shared_50d0d8d: 'Shared',
        show_places_9daa640: 'Show places',
        sort_by_9bb640e: 'Sort by:',
        university_715432d: 'University',
        wait_for_others_to_share_their_exp_cafd50a: 'WAIT FOR OTHERS TO SHARE THEIR EXPERIENCES OR'
      },
      rewardAdmin: {
        admin_4e7afeb: 'Admin',
        admin_note_4193c1a: 'Admin note',
        admin_sections_80deff5: 'Admin sections',
        admin_system_e07b109: 'Admin System',
        analytics_25bc962: 'Analytics',
        approve_7b2c7f1: 'Approve',
        approved_slots_af4ed8a: 'Approved slots',
        comments_fce06e2: 'Comments',
        decision_7f59a1f: 'Decision',
        eligible_comments_bcd45f2: 'Eligible comments',
        email_a_z_05d6a57: 'Email (A–Z)',
        email_this_student_about_the_hk_50_ebb8505: 'Email this student about the HK$50 Starbucks reward. The message includes their live checklist (review, photos, comments) and a link to their profile.',
        flags_5d72875: 'Flags',
        incomplete_387fd1b: 'Incomplete',
        loading_submission_b0d8c6c: 'Loading submission…',
        mark_issued_ddacea2: 'Mark issued',
        most_recent_activity_e73e4ff: 'Most recent activity',
        name_a_z_c93e4c5: 'Name (A–Z)',
        no_comments_found_for_this_user_e19abb6: 'No comments found for this user.',
        no_submissions_yet_users_appear_he_b87ec6d: 'No submissions yet. Users appear here when they progress on the first-50 reward.',
        not_started_db2c45d: 'Not started',
        optional_note_for_the_user_or_inte_f8e6661: 'Optional note for the user or internal log',
        optional_personal_note_from_you_sh_a0cf2a2: 'Optional personal note from you (shown in the email)',
        order_1d75774: 'Order',
        own_listing_9aeb139: 'Own listing',
        photos_c8b2e86: 'Photos',
        progress_reminder_email_0834ecf: 'Progress reminder email',
        refresh_queue_50c3cf3: 'Refresh queue',
        reject_2b03b59: 'Reject',
        reminders_are_only_available_for_s_15dd308: 'Reminders are only available for students who have not started or are still in progress (not pending verification, approved, or issued).',
        repetitive_3ffacb5: 'Repetitive',
        review_evidence_ab34d96: 'Review evidence',
        reward_approvals_and_aggregated_us_21b1cbc: 'Reward approvals and aggregated usage metrics.',
        reward_queue_2e39291: 'Reward queue',
        select_a_submission_from_the_list__c02db7e: 'Select a submission from the list to review evidence and decide.',
        status_workflow_bbc54ed: 'Status (workflow)',
        too_short_b126726: 'Too short',
        updating_3ab0d73: 'Updating…',
        url_is_not_allowed_http_https_only_274bdb6: 'URL is not allowed (http/https only)',
        view_on_site_b66ea87: 'View on site ↗'
      },
      showReview: {
        be_the_first_to_comment_dc12124: 'Be the First to Comment',
        bed_type_f5d7e43: '🛏️ Bed Type',
        biggest_problem_46e04d0: '⚠️ Biggest Problem',
        bills_included_e196739: '📋 Bills Included',
        cleanliness_condition_c3040e5: 'Cleanliness & Condition',
        comment_153d7a5: 'Comment',
        content_2459603: 'Content:',
        cost_transparency_07c6382: 'Cost Transparency',
        delete_9485989: 'delete',
        deposit_82da2bf: '🔑 Deposit',
        edit_9ead47a: 'edit',
        helpful_02f9858: 'Helpful?',
        images_09e871c: 'Images',
        internet_utilities_reliability_6886085: 'Internet & Utilities Reliability',
        leave_a_comment_5a91cc8: 'Leave a Comment',
        listing_accuracy_a4530e1: 'Listing Accuracy',
        living_comfort_3754e95: 'Living Comfort',
        loading_review_a539d74: 'Loading review…',
        location_convenience_b5ea55e: 'Location Convenience',
        maintenance_responsiveness_2cf7ad6: 'Maintenance Responsiveness',
        monthly_rent_4a0531d: '💰 Monthly Rent',
        no_image_33cf70a: 'No Image',
        noise_exposure_9c76355: 'Noise Exposure',
        recommended_7a9fe3e: '👍 Recommended?',
        review_not_found_49fa790: 'Review not found.',
        room_type_763a5f9: '🏠 Room Type',
        roommates_be61f72: '👥 Roommates',
        safety_db6e7e4: 'Safety',
        shared_bathroom_4d9173c: '🚿 Shared Bathroom',
        space_adequacy_1631412: 'Space Adequacy',
        stay_duration_6919b3d: '📅 Stay Duration',
        submit_review_c191880: 'Submit Review',
        user_3123a0e: 'User:',
        write_your_review_here_26c1eea: 'Write your review here...',
        yourself_803037d: 'Yourself'
      },
      userInfo: {
        academic_year_5f1566b: 'Academic Year:',
        account_credentials_481ad68: 'Account Credentials',
        choose_avatar_98122fb: 'Choose Avatar',
        current_password_4d59678: 'Current Password',
        email_84add5b: 'Email',
        enter_6_digit_code_4c9c785: 'Enter 6-digit code',
        enter_your_current_password_9149cfc: 'Enter your current password',
        enter_your_new_password_7bec90c: 'Enter your new password',
        female_b7c17e9: 'Female',
        gender_8a754c6: 'Gender',
        male_3f3a489: 'Male',
        manage_your_profile_settings_updat_6a6cb13: 'Manage your profile settings, update your credentials, and customize your preferences.',
        new_password_4894cb3: 'New Password',
        other_6e6a6f2: 'Other',
        profile_settings_df4b081: 'Profile Settings',
        save_profile_changes_24dcd52: 'Save Profile Changes',
        send_code_f687607: 'Send Code',
        university_715432d: 'University',
        update_credentials_f749a73: 'Update Credentials',
        username_84c2901: 'Username',
        verification_code_50cdc18: 'Verification Code'
      },
      userProfile: {
        '50_for_50_starbucks_review_giveawa_9329564': '50 for 50 – Starbucks Review Giveaway',
        all_reward_spots_are_filled_for_th_adb6f04: 'All reward spots are filled for this round.',
        bio_b31fc96: 'Bio',
        budget_7aeba4c: 'Budget',
        edit_profile_cd280a4: 'Edit Profile',
        email_verified_9d240e9: 'Email Verified',
        housing_preferences_45c40e9: 'Housing Preferences',
        id_verified_3e759b1: 'ID Verified',
        loading_33ce417: 'Loading…',
        logout_e43d612: 'Logout',
        near_campus_ef995c6: 'Near campus',
        open_review_b085791: 'Open review',
        photos_c8b2e86: 'Photos',
        qualifying_listing_one_reward_007a62d: 'Qualifying listing (one reward)',
        starbucks_review_giveaway_requirem_deb6ec8: 'Starbucks review giveaway requirements',
        washer_dryer_wi_fi_cb5014d: 'Washer/dryer, Wi-Fi',
        written_detail_fc01c38: 'Written detail'
      }
  },
  emptyState: {
    notReviewedYet: 'Not reviewed yet'
  },
  legal: {
    backToApp_23fdde0: 'Back to Sparrow',
    breadcrumbHome_996be5e: 'Home',
    onThisPage_993081e: 'On this page'
  }
};
